/** Одинаковые причины (хуки на нескольких строках, один отказ дважды) — один раз. */
export const uniqueMessages = (messages: readonly string[]): string[] => {
    const seen = new Set<string>();
    return messages.filter((message) => {
        const key = message.trim();
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
    });
};
